import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'UI/res';

export const useStyles = makeStyles({
  fileButton: {
    padding: 0,
    minWidth: 'unset',
    textTransform: 'none',
    justifyContent: 'flex-start',
    color: colors.navLink,
    fontWeight: 'normal',
    '&:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'underline'
    }
  }
});
